<template>
  <div class="post">
    <v-container fluid>
        <v-row  class="py-0">
            <v-col class="pa-0">
                <div style="height: calc((100vh - 110px) / 2); position: relative; ">
                <v-img :src="'https://nncms.actstudio.xyz/'+post.cover.path"  style="position: absolute;width: 100%; height: 100%; object-fit: cover; z-index: 0;" ></v-img>
                    
                    <div style="background: rgb(90,35,178); background: linear-gradient(0deg, rgba(90,35,178,0.3) 12%, rgba(90,35,178,0.3) 52%, rgba(90,35,178,.5) 100%); position:relative;">

                        
                    </div>
                </div>
            </v-col>
        </v-row>

     </v-container>
     <v-container >
         <v-row  class="px-10" >
             
             <v-col class="text-start">
                 <span class="color-morado">{{post.category.title}}</span>
             </v-col>
             
             <v-col class="text-end">
                 <span class="color-morado">{{formatDate(post._created)}}</span>
             </v-col>

         </v-row>
         <v-row class="px-10 color-morado">
             <v-col>
                 <span class="enfasis-size bold" >{{post.title}}</span>
                 <hr class="mt-6" style="max-width: 80%;">
                 <span class="d-inline-block my-8 mr-4">SHARE</span>
                 <v-img src="../assets/img/url-editado.svg" width="24" class="d-inline-block"></v-img>
             </v-col>

         </v-row>
     </v-container>

     <v-container>
         
         <template v-for="(row,r) in post.content">
           <v-row :key="'renglon-'+r" >

             <template v-for="(col,c) in row.value">
               <v-col cols="12" :sm="12/row.value.length" :key="'col-'+r+'-'+c" class="px-16">
                 <template v-for="(comp,cp) in col.children">
                   <template v-if="comp.component=='text'">
                    <div :key="'component-'+r+'-'+c+'-'+cp" v-html="comp.settings.text">

                    </div>
                   </template>
                   <template v-if="comp.component=='image'">
                     <v-img :src="'https://nncms.actstudio.xyz/'+comp.settings.image.path" :key="'component-'+r+'-'+c+'-'+cp"></v-img>

                   </template>
                   <template v-if="comp.component=='html'">
                    <div :key="'component-'+r+'-'+c+'-'+cp" v-html="comp.settings.html">


                    </div>
                   </template>
                   <!-- <template>

                     {{comp}}
                   </template> -->

                 </template>

               </v-col>

             </template>

           </v-row>

         </template>
         
     </v-container>

     <v-container>
       <v-row>
             <v-col class="text-center">
                 <span class="enfasis-size bold color-morado">Lo más reciente</span>
             </v-col>
         </v-row>
       <v-row>
              <template v-for="(recent,rec ) in recentPosts">
                  
                    <v-col cols="12" sm="6" md="4" class="color-morado px-1" :key="'recent-'+rec" v-if="rec<2" >
                <!-- <span class="d-block single-item-size my-4">{{recent.category.display}} </span> -->
                    <v-img :src="'https://nncms.actstudio.xyz/'+recent.cover.path" height="292"></v-img>
                    <span class="d-block single-item-size my-4">{{formatDate(post._created)}} </span>
                    <span class="titulos-size bold d-block mb-2">{{recent.title}}</span>
                    <span class="single-item-size d-block">{{recent.description}}</span>
                    <router-link :to="'/blog/'+recent.url"><span class="single-item-size d-block mt-8">Leer más</span> </router-link>
                  </v-col> 
                  
              </template>
         </v-row>
     </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      recentPosts:[],
      post: {
        cover:{
          path:''
        },
        _created:''
      },
      date:'',
    }
  },
  methods:{
    formatDate:function(date){
        var a = new Date(date * 1000);
        var months = ['Enero','Febrero','Marzo','April','Mayo','Junio','Julio','Augosto','Septiembre','Octubre','Noviembre','Deciembre'];
        var fecha =  a.getDate() + ' ' + months[a.getMonth()] + ' '  + a.getFullYear();
        return fecha;

    }
  },
  mounted: function () {
    fetch(
      "http://nncms.actstudio.xyz/api/collections/get/Posts?token=8cf7ca41761951fdde0c1e2cfda401",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {
            url: this.$route.params.url,
          },
          populate: 1,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.post = res.entries[0]));

    fetch('http://nncms.actstudio.xyz/api/collections/get/Posts?token=8cf7ca41761951fdde0c1e2cfda401', {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
          
      })
    })
    .then(res=>res.json())
    .then(res => this.recentPosts = res.entries); 
      
  },
  watch:{
        $route(){
            fetch('http://nncms.actstudio.xyz/api/collections/get/Posts?token=8cf7ca41761951fdde0c1e2cfda401', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                filter: {
                    url: this.$route.params.url,
                    destacado: true
                },
                populate: 1, // resolve linked collection items
            })
        })
        .then(res=>res.json())
        .then(res => this.post = res.entries[0]);
        }
    }
};
</script>